import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

export const TradeStationConnected = () => {
  const navigate = useNavigate();
  const { refreshUserSettings, user } = useContext(AuthContext);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        if (refreshUserSettings) {
          await refreshUserSettings();
        }
      } catch (e) {
        console.error(e);
      }
      if (cancelled) return;
      // Resume onboarding after broker OAuth; ?ts=1 shows the short “connected” confirmation
      navigate('/onboarding?ts=1', { replace: true });
    })();
    return () => { cancelled = true; };
  }, [navigate, refreshUserSettings, user?.id]);

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Successfully connected to TradeStation</h2>
      <div style={{
        marginTop: '30px',
        padding: '20px',
        background: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '8px',
        fontSize: '0.9em',
        lineHeight: '1.6',
        opacity: 0.85
      }}>
        <p style={{ margin: 0 }}>
          <strong>Important Disclosure:</strong> PrecisionTrader is not affiliated or associated with, or a partner of,
          or an agent, representative, delegate, associated person or introducing broker for, any TradeStation company.
          The products and services offered by PrecisionTrader are not sponsored, endorsed, sold or promoted by any
          TradeStation company, and TradeStation makes no representation regarding any products or services offered
          by PrecisionTrader. Equities, equity options and commodity futures products and services are offered by
          TradeStation Securities, Inc. (Member NYSE, FINRA, CME and SIPC).
        </p>
      </div>
    </div>
  );
};
